module.exports = __webpack_public_path__ + "img/headofficeroundtrans.3261708c.png";